import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { TokenResponse } from "../lib/api";

type Session = {
  accessToken: string;
  refreshToken: string;
  userId: string;
  kind: TokenResponse["kind"];
  roles: string[];
};

type AuthState = {
  session: Session | null;
  setSession: (t: TokenResponse) => void;
  clear: () => void;
};

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      setSession: (t) =>
        set({
          session: {
            accessToken: t.access_token,
            refreshToken: t.refresh_token,
            userId: t.user_id,
            kind: t.kind,
            roles: t.roles,
          },
        }),
      clear: () => set({ session: null }),
    }),
    { name: "sixa.auth" },
  ),
);
